import CryptoJS from 'crypto-js';
import { Cookies } from 'react-cookie';
const secretKey = process.env.REACT_APP_E_KEY;

const cookies = new Cookies();
const virtualPath = '';

export const encryptData = (data) => {
    try {
        const dataString = typeof data === 'object' ? JSON.stringify(data) : data;
        const encrypted = CryptoJS.AES.encrypt(dataString, secretKey).toString();
        return encrypted;
    } catch (error) {
        return null;
    }
};


export const decryptData = (encryptedData) => {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        if (!decryptedData) {
            throw new Error('Decryption failed or data is empty');
        }
        try {
            return JSON.parse(decryptedData);
        } catch (jsonError) {
            return decryptedData;
        }
    } catch (error) {
        return null;
    }
};

export const SetSession = (type, key, value) => {
    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;
    let encryptedValue = value ? encryptData(value) : null;
    if (type.toLowerCase() === 'cookies') {
        cookies.set(tempKey, encryptedValue, {
            path: "/",
            expires: new Date(Date.now() + 60 * 60 * 1000 * 8),
            secure: true,
            sameSite: "None"

        });
    } else if (type.toLowerCase() === 'localstorage') {
        window.localStorage.setItem(tempKey, encryptedValue);
    } else if (type.toLowerCase() === 'sessionstorage') {
        sessionStorage.setItem(tempKey, encryptedValue);
    }
};


export const GetSession = (type, key) => {
    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;
    let data;

    if (type.toLowerCase() === 'localstorage') {
        data = window.localStorage.getItem(tempKey);
    } else if (type.toLowerCase() === 'cookies') {
        data = cookies.get(tempKey);
    } else if (type.toLowerCase() === 'sessionstorage') {
        data = sessionStorage.getItem(tempKey);
    } else {
        return null;
    }
    return data ? decryptData(data) : null;
}

export const RemoveSession = (type, key) => {
    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;
    if (type.toLowerCase() === 'localstorage') {
        localStorage.removeItem(tempKey);
    } else if (type.toLowerCase() === 'cookies') {
        cookies.remove(tempKey, { path: '/' });
    } else if (type.toLowerCase() === 'sessionstorage') {
        sessionStorage.removeItem(tempKey);
    }
}


export const downloadBase64Zip = (base64String, fileName = "MyData") => {
    // Convert base64 → binary
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create blob
    const blob = new Blob([byteArray], { type: "application/zip" });

    // Create download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.zip`;

    // Trigger click
    link.click();

    // Clean
    URL.revokeObjectURL(link.href);
};

